import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const FullWidth = styled('div')`
  ${media.smDown`
    margin: 0 ${({ theme }) => -theme.x2space}rem;
  `}
`;
